
<fury-page-layout mode="card">
    <fury-page-layout-header>
        <fury-breadcrumbs [@fadeInRight]  current="View Menu Details"></fury-breadcrumbs>
      </fury-page-layout-header>
      <fury-page-layout-content [@fadeInUp]>
        <div [@fadeInUp] class="card">
            <div *ngIf="!isLoading">
                <div class="detailbox">
                        <div class="detailarea">
                            <label>Title: </label> {{menuDetails?.title}}
                        </div>
                        <div class="detailarea">
                            <label>Frontend Component Name: </label> {{menuDetails?.frontendComponentName}}
                        </div>
                        <div class="detailarea">
                            <label>Backend Component Name: </label> {{menuDetails?.backendComponentName}}
                        </div>
                        <div class="detailarea">
                            <label>Description: </label> {{menuDetails?.description}}
                        </div>
                        <div class="detailarea">
                            <label>Active: </label> {{menuDetails?.isActive ? 'Yes' : "No"}}
                        </div>
                        <div class="detailarea">
                            <label>Children: </label> <span *ngIf="!menuDetails?.children.length">No Children Found</span>
                            
                        </div>
                </div>
                <fury-list name="{{filterValue}}" [columns]="columns" (filterChange)="onFilterChange($event)">
                    <div class="actions" *ngIf="itemList?.length > 0">
                        <button class="create" type="button" routerLink="/settings/menu/menu-children-add/{{adminMenuId}}" mat-mini-fab color="primary">
                          <mat-icon>add</mat-icon>
                        </button>
                      </div>
                    <table [dataSource]="dataSource" #dataTable mat-table cdkDropList  (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="dragDisabled">
                        <!-- actions Column -->
                        <ng-container matColumnDef="actions">
                            <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
                            <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                                <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                                    (click)="$event.stopPropagation()">
                                    <mat-icon>more_horiz</mat-icon>
                                </button>
                                <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                                    <button mat-menu-item routerLink="/settings/menu/view-menu-details/{{row?.adminMenuId}}">
                                        <span>View</span>
                                    </button>
                                    <button mat-menu-item (click)="navigateEditePage(row?.adminMenuId)">
                                        <span>Edit</span>
                                    </button>
                                    <button mat-menu-item (click)="deleteMenu('delete', row?.adminMenuId)">
                                        <span>Delete</span>
                                    </button>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="drag">
                            <th mat-header-cell class="image-cell" *matHeaderCellDef>Drag</th>
                            <td mat-cell class="image-cell" *matCellDef="let element">
                                <mat-icon class="dragCursor" (mousedown)="dragDisabled = false;"
                                >drag_handle</mat-icon>
                            </td>
                        </ng-container>
                    
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef>Title</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.title}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="frontendComponentName">
                            <th mat-header-cell *matHeaderCellDef>Frontend Component Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.frontendComponentName}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="backendComponentName">
                            <th mat-header-cell *matHeaderCellDef>Backend Component Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.backendComponentName}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="isActive">
                            <th mat-header-cell *matHeaderCellDef>Active</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.isActive ? 'Yes' : 'No'}}
                            </td>
                        </ng-container>
                        
                        <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                        <tr *matRowDef="let row; columns: visibleColumns"
                            class="clickable route-animations-elements" mat-row cdkDrag
                            [cdkDragData]="row">
                        </tr>
                        <div *cdkDragPlaceholder></div>
                    </table>
                    <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
                        No Menus found.
                    </div>
                    <!-- <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
                        showFirstLastButtons
                        [selectConfig] = "selectConfig"
                        [ngClass]="{'mat-pegig': pageSize === 9999}"
                        aria-label="Select page of periodic elements">
                    </mat-paginator> -->
                   
                   
                </fury-list>
            </div>
            <div *ngIf="isLoading">Please wait...</div>
        </div>
      </fury-page-layout-content>
</fury-page-layout>








